// @ts-nocheck

import type { User } from 'client/js/redux/domains/User/types';
import {
  DELETE_TEAM_MEMBER,
  GET_PERMISSIONS,
  LOAD_BY_EMAIL,
  SAVE_TEAM_MEMBER,
  TEAM_MEMBERS_LOAD,
  UNDELETE_TEAM_MEMBER,
  UPDATE_TEAM_MEMBER,
} from '../actions/TeamActions';
import { LOADING_STATUS } from '../support/constants';
import { reducerWrapper } from '../support/utils';
import type { TeamMember, TeamReducer } from '../types/teamTypes';
const INIT_STATE: TeamReducer = {
  loadingStatus: LOADING_STATUS.INIT,
  permissionsLoadingStatus: LOADING_STATUS.INIT,
  error: null,
  members: [],
  user: null,
  permissionsByUserId: {},
};

function combineTeamMembers(teamMembers: Array<TeamMember>, user: User) {
  const index = teamMembers.findIndex((member) => member.id === user.id);

  if (index >= 0) {
    const members = teamMembers.slice();
    members[index] = Object.assign({}, members[index], user);
    return members;
  }

  return teamMembers.concat(user);
}

function Handler(
  state: TeamReducer,
  action: {
    type: string;
    data: any;
  }
) {
  const { data } = action;

  switch (action.type) {
    case TEAM_MEMBERS_LOAD.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        members: data,
      });

    case SAVE_TEAM_MEMBER.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        members: data,
      });

    // Same logic to handle delete and undelete
    case DELETE_TEAM_MEMBER.response:
    case UNDELETE_TEAM_MEMBER.response:
      return Object.assign({}, state, {
        members: combineTeamMembers(state.members, data),
      });

    case LOAD_BY_EMAIL.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        user: data,
      });

    case GET_PERMISSIONS.request:
      return Object.assign({}, state, {
        permissionsLoadingStatus: LOADING_STATUS.LOADING,
      });

    case GET_PERMISSIONS.response:
      return Object.assign({}, state, {
        permissionsLoadingStatus: LOADING_STATUS.LOADED,
        permissionsByUserId: { ...state.permissionsByUserId, ...data },
      });

    case UPDATE_TEAM_MEMBER.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        members: data,
      });

    default:
      return state;
  }
}

export default reducerWrapper(INIT_STATE, Handler, {
  request: [LOAD_BY_EMAIL, TEAM_MEMBERS_LOAD, SAVE_TEAM_MEMBER, UPDATE_TEAM_MEMBER],
  error: [LOAD_BY_EMAIL, TEAM_MEMBERS_LOAD, SAVE_TEAM_MEMBER, GET_PERMISSIONS, UPDATE_TEAM_MEMBER],
  resetOn: ['APP_CHANGE'],
});
